import anylogger from '@app/anylogger'
import { useDependencyWithRefresh, SetterFunction } from './useDependencyWithRefresh'

const log = anylogger('useDependency')

export function useDependency<T>(dependencies: any[], setter: SetterFunction<T>): T | undefined {
	const [state, refresh] = useDependencyWithRefresh(dependencies, setter)
	return state
}
